import React from 'react'
import { useLocation } from 'react-router-dom';


export const NavBar = () => {
    const location = useLocation();


    
  if (location.pathname !== '/') {
    return null; 
  }
  return (
    <header className='flex justify-center items-center '>
        <h1 className='m-5 text-white text-4xl sm:text-3xl'>CV de Andrés Pujol</h1>
    </header>
  )
}
